import 'tom-select/dist/css/tom-select.default.css';
import controller_0 from '@symfony/ux-live-component/dist/live_controller.js';
import '@symfony/ux-live-component/dist/live.min.css';
import controller_1 from '@symfony/ux-toggle-password/dist/controller.js';
import '@symfony/ux-toggle-password/dist/style.min.css';
import { Controller } from '@hotwired/stimulus';
export default {
  'symfony--ux-autocomplete--autocomplete': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@symfony/ux-autocomplete/dist/controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
  'live': controller_0,
  'symfony--ux-toggle-password--toggle-password': controller_1,
  'symfony--ux-turbo--turbo-core': class extends Controller {
      constructor(context) {
          super(context);
          this.__stimulusLazyController = true;
      }
      initialize() {
          if (this.application.controllers.find((controller) => {
              return controller.identifier === this.identifier && controller.__stimulusLazyController;
          })) {
              return;
          }
          import('@symfony/ux-turbo/dist/turbo_controller.js').then((controller) => {
              this.application.register(this.identifier, controller.default);
          });
      }
  },
};